import React from "react";
import MetaTitle from "~/components/Shared/MetaTitle";
import { isMobile, isTablet } from 'react-device-detect';
import DesktopContent from "../DesktopContent/DesktopContent";
import MobileContent from "../MobileContent/MobileContent";

const Index = () => {

  const detectAllTablets = () => {
    const screenWidth = window.innerWidth;

    // Detect iPad (Ipad Pro & Air - large iOS tablets )
    const isIpad = /iPad|Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;

    // Detect Android tablet (Samsung Galaxy Tab, etc.)
    const isAndroidTablet = /Android/.test(navigator.userAgent) && !/Mobile/.test(navigator.userAgent);

    // Detect Windows tablet (Surface, etc.)
    const isWindowsTablet = /Windows/.test(navigator.userAgent) && navigator.maxTouchPoints > 0;

    // Touch support
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Size-based detection for undetected tablets
    const isProbablyTablet = hasTouchScreen && screenWidth >= 539 && screenWidth <= 1025;

    return isIpad || isAndroidTablet || isWindowsTablet || isProbablyTablet;
  };

  const isAnyTablet = detectAllTablets();

  // All tablets (small and large) + mobiles = MobileContent
  const showMobileView = isMobile || isTablet || isAnyTablet;

  return (
    <React.Fragment>
      <MetaTitle>Electronic Signing</MetaTitle>

      {showMobileView && <MobileContent />}

      {!showMobileView && <DesktopContent />}
    </React.Fragment>
  );
};

export default Index;

